<template>
  <section
    :class="{
      'lang-kr': lang == $config.LANG_KOR, //한국
      'lang-en': lang == $config.LANG_ENG, //영어
      'lang-mm': lang == $config.LANG_MMR, //미얀마
      'lang-kh': lang == $config.LANG_CAM, //캄보디아
      'lang-vnd': lang == $config.LANG_VTM, //베트남
      'lang-sin': false, //싱가포르
      'layout': $route.meta.layout == 'default',
      'motp-content': $route.meta.layout  === undefined
    }"
  >
    <!-- header -->
    <header class="sticky">
      <app-bar
        :transparent="$route.meta.transparent || false"
        :goback="$route.meta.goback"
        :nation="$route.meta.nation || false"
        :home="$route.meta.home || false"
        :menu="$route.meta.menu"
      />
    </header>
    <!-- header end -->
    <div class="main">
      <router-view>
        <template #menuTitle>
          <div class="title">
            <h2>{{$t(menuTitle)}}</h2>
          </div>
        </template>
      </router-view>
    </div>
  </section>
</template>

<script>
import AppBar from "@/components/layout/AppBar";
import { mapFields } from "vuex-map-fields";
export default {
  components: {
    AppBar,
  },
  computed: {
    ...mapFields(["menuTitle", "lang"]),
  },
};
</script>